module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0c8f529bb6607606374003ef056226d7.png";